exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "._2CDPanXY10TQveH0kG2xKQ{position:absolute;top:70px;right:80px;width:200px;border:1px solid transparent;padding:5px 5px 5px 10px;background-color:#d9534f;border-color:#d43f3a;color:#fff;z-index:2;opacity:.7;font-size:12px}", ""]);

// exports
exports.locals = {
	"invalidWarning": "_2CDPanXY10TQveH0kG2xKQ"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true}!./app/styles/aoi/InvalidDrawWarning.css
// module id = 1454
// module chunks = 1